import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Render immediately so the page always shows content, even when opened outside
// Outlook or if Office.js is slow/unavailable. App (via useOfficeContext)
// detects the Office host and renders the right experience or a landing page.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Configure startup behavior only when actually running inside Office.
try {
  if (typeof Office !== "undefined" && Office.onReady) {
    Office.onReady((info) => {
      if (info && info.host === Office.HostType.Outlook) {
        try {
          void Office.addin.setStartupBehavior(Office.StartupBehavior.load);
        } catch {
          // Not supported on this platform (classic Outlook desktop / Mac)
        }
      }
    });
  }
} catch {
  // Office.js not available (opened outside Outlook) — nothing to configure.
}
